import { BUTTON_CLASS } from './buttons.scss';
import { SOUND_ID } from './audio.scss';
import { CIRCLE_CLASS, CIRCLE_CONTAINER_CLASS } from './circles.scss';
import { SPEAKER_INNER_CLASS } from './speaker.scss';

import { showSelectedCircles, listeAnimationEvents } from './circles';
import { cabinForIndex, handleButtonsClick } from './buttons';
import { handleSpeackerClick } from './speaker';
import { setupMediaElement, setVolumeForCabin } from './audio';

$(document).ready(() => {

	// get required jquery vars
	const $buttons = $(`.${BUTTON_CLASS}`);
	const audioElement = $(`#${SOUND_ID}`)[0];
	const $circles = $(`.${CIRCLE_CLASS}`);
	const $circlesContainers = $(`.${CIRCLE_CONTAINER_CLASS}`);
	const $speakerInner = $(`.${SPEAKER_INNER_CLASS}`);

	// set correct cabin and circles based on button selected
	const activeButtonIndex = $buttons.index($('.active'));
	const selectedCabin = cabinForIndex(activeButtonIndex); // @TODO : persist it in localStorage or cookie
	showSelectedCircles($circlesContainers, selectedCabin, true);

	// setup circle animations event listeners
	listeAnimationEvents($circles);

	// setup Web Audio API context/node/source/gain using HTML5 audio element on first click
	handleSpeackerClick($speakerInner, audioElement, setupMediaElement);

	handleButtonsClick($buttons, (selectedCabin) => {
		showSelectedCircles($circlesContainers, selectedCabin);
		setVolumeForCabin(selectedCabin);
	});

});
